module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Save as GPX file":"Als GPX-Datei speichern"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/routing/DownloadGPX.vue
// module id = Van3
// module chunks = 1